function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IrssCircle = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    notChangeable: true,
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    rx: "16",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4682 21.2738C13.4682 22.4983 12.4668 23.494 11.2351 23.494C10.0033 23.494 9.00195 22.4983 9.00195 21.2738C9.00195 20.049 10.0033 19.0532 11.2351 19.0532C12.4668 19.0532 13.4682 20.0494 13.4682 21.2738ZM26.2299 23.4944C26.2636 18.3874 23.8889 13.3273 19.9099 10.0976C16.8785 7.58113 12.9537 6.1547 9.00195 6.16806V10.1316C13.6778 10.0778 18.2861 12.6076 20.6878 16.6048C21.9585 18.6785 22.6327 21.0592 22.6368 23.4875H26.2299V23.4944ZM20.1403 23.4944C20.1602 20.2109 18.5906 16.9812 16.0261 14.9221C14.0637 13.3208 11.54 12.419 9.00236 12.4328V15.7701C11.763 15.7365 14.47 17.3111 15.7892 19.7264C16.432 20.882 16.7697 22.1807 16.7706 23.5013H20.1403V23.4944Z",
    fill: "white"
  }));
});